// extracted by mini-css-extract-plugin
export default {"midnightIndicator":"styles_midnightIndicator__zevST"};